import { Mods, mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const Root = styled.th<StyledMods<Mods<'sticky' | 'bordered'> & { isRowMenuStickyActive?: boolean }>>`
    background-color: transparent;
    border-top: 1px solid transparent;
    border-right: 1px solid transparent;
    border-bottom: 1px solid transparent;

    ${mods.sticky.true`
        position: sticky;
        right: -1px; // -1 for Intersection Observer
        background-color: ${theme.color.white100};

        &::before {
            content: '';
            position: absolute;
            background-color: ${theme.color.white100};

            top: -1px;
            right: -1px;
            bottom: -1px;
            left: 0px;

         
            border-bottom: 1px solid ${theme.color.white100};
            border-top: 1px solid ${theme.color.white100};
            border-right: 1px solid ${theme.color.white100};
            z-index: -1;

            ${mods.bordered.true`
                left: -1px;
                border-left: 1px solid ${theme.color.midnight50};
                background-color: ${theme.color.white100};

                ${mods('isRowMenuStickyActive', true)`
                    left: -2px;
                `}
            `}

            ${mods.bordered.false`
                ${mods('isRowMenuStickyActive', true)`
                    left: -1px;
                `}
            `}
        }
    `};
`;
